// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

import get from "../../utils/GetNested";

export const GetWorkflowTemplate = CreateProcess({
	method: "GET",
	name: "GetWorkflowTemplate",
	type: "WORKFLOWS:TEMPLATE.GET",

	request: (props) => ({
		url: `/api/workflow-templates/${props.workflowTemplateID}/`,
	}),

	success: (response) =>
		fromJS({
			template: response.data.template,
			templateActorsMap: response.data.display_user_map,
			templateSignaturesMap: response.data.signature_request_map,
		}),
});

export const GetWorkflowTemplates = CreateProcess({
	method: "GET",
	name: "GetWorkflowTemplates",
	type: "WORKFLOWS:TEMPLATES.GET",

	request: (props) => {
		const workflowTemplateName = get(props, ["params", "payload", "name"], props.name) || "";

		return {
			url: `/api/workflow-templates/?name=${workflowTemplateName}`,
		};
	},

	success: (response) => response.data,
});

export const SubmitWorkflowTemplate = CreateProcess({
	method: "POST",
	name: "CreateWorkflowTemplate",
	type: "WORKFLOWS:TEMPLATE.CREATE",

	request: (props) => ({
		url: "/api/workflow-templates/create/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const UpdateWorkflowTemplate = CreateProcess({
	method: "POST",
	name: "UpdateWorkflowTemplate",
	type: "WORKFLOWS:TEMPLATE.UPDATE",

	request: (props) => ({
		url: `/api/workflow-templates/${props.workflowTemplateID}/`,
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const DeleteWorkflowTemplate = CreateProcess({
	method: "DELETE",
	name: "DeleteWorkflowTemplate",
	type: "WORKFLOWS:TEMPLATE.DELETE",

	request: (props) => ({
		url: `/api/workflow-templates/${props.workflowTemplateID}/`,
	}),

	success: (response) => fromJS(response.data),
});

export const LaunchWorkflow = CreateProcess({
	method: "POST",
	name: "LaunchWorkflow",
	type: "WORKFLOWS:WORKFLOW.LAUNCH",

	request: (props) => ({
		url: "/api/launch-workflow/",
		payload: props.payload,
	}),

	success: (response) => {
		return fromJS(response.data);
	},
	failure: (response) => {
		return fromJS(response);
	},
});
